export default __webpack_public_path__ + "static/media/equipe.585a4dfe.png";